<div id="Map-container" [class.mobile]="isMobile()">
  @if (isLoading()) {
    <div class="spinner-container">
      <app-spinner></app-spinner>
    </div>
  }

  <div class="inset-shadow-container"></div>
  <div id="Map"></div>

  <button
    id="zoom-out"
    class="drop-shadow"
    (click)="onZoomOut()"
    aria-label="Zoom Out"
  >
    <i nz-icon nzType="icons:minus" class="noMarginRight"></i>
  </button>

  <button
    id="zoom-in"
    class="drop-shadow"
    (click)="onZoomIn()"
    aria-label="Zoom In"
  >
    <i nz-icon nzType="icons:plus" class="noMarginRight"></i>
  </button>
</div>
